<template>
  <img class="avatar jm-img-circle jm-img-cover" />
</template>

<script>
export default {
  name: 'StylistAvatar'
}
</script>

<style lang="scss" scoped>
.avatar {
  width: 64px;
  height: 64px;
}
</style>
